import React, { useState } from 'react'
import style from "./BusinessDetailsOverseas.module.css"
import cogoToast from 'cogo-toast-react-17-fix';
const CompanyBillingAddress = ({data, onSave, state}) => {

    const companyAddresses=data
    const hasAddresses = companyAddresses.length > 0
    
    const legalName = data?.legal_name_of_business;
    const gstinStatus = data?.gstin_status;
    const gstin = data?.gstin
    const [selectedIndex, setSelectedIndex] = useState(null)
    const [addressLine1, setAddressLine1] = useState("");
    const [addressLine2, setAddressLine2] = useState("");
    const [city, setCity] = useState("");
    const [stateName, setStateName] = useState(state);
    const [pincode, setPincode] = useState("");
    const [country, setCountry] = useState("India")
    const [errors, setErrors] = useState({})
    const [isSaved,setIsSaved]=useState(false)

  const handleLocationSelect = (loc, index) => {
    setSelectedIndex(index);
    setAddressLine1(loc.address1 || "");
    setAddressLine2(loc.address2 || "");
    setCity(loc.city || "");
    // setStateName(loc.state_name || "");
    setPincode(loc.pincode || "");
    // setCountry(loc.country || "India");

    setErrors({})
    setIsSaved(false)
    onSave?.(null)
  }
  const handleDiscard = () => {
    setSelectedIndex(null);
    setAddressLine1("");
    setAddressLine2("");
    setCity("");
    setStateName("");
    setPincode("");
    setCountry("India");
    setErrors({})
    setIsSaved(false)
    onSave?.(null)
    cogoToast.info("Changes discarded")
  }
  const handleSave = () => {
        if (!validate()) {
          cogoToast.error(
            errors.selection || "Please fix the errors before saving"
          );
          return;
        }


        try {
            const billingData = {
              address1: addressLine1.trim(),
              address2: addressLine2.trim(),
              city: city,
              state: stateName,
              pincode: pincode,
              country: country,
            };
            onSave?.(billingData);
            setIsSaved(true)
            cogoToast.success("Billing address saved")
          } catch (err) {
            console.error("Error saving billing address:", err);
            cogoToast.error("Failed to save billing address. Please try again.")
          }
        }
  const handleLine1Change = (e) => {
    setAddressLine1(e.target.value)
    if (errors.addressLine1) setErrors(prev => ({ ...prev, addressLine1: "" }))
    if (isSaved) {
      setIsSaved(false)
      onSave?.(null)
    }
  }
 
  const handleLine2Change = (e) => {
    setAddressLine2(e.target.value)
    if (errors.addressLine2) setErrors(prev => ({ ...prev, addressLine2: "" }))
    if (isSaved) {
      setIsSaved(false)
      onSave?.(null)
    }
  }
  const validate = () => {
    const newErrors = {}
 
    if (hasAddresses && selectedIndex === null) {
      newErrors.selection = "Please select a billing address"
    }
 
    if (!addressLine1.trim()) {
      newErrors.addressLine1 = "Address Line 1 is required"
    } if (addressLine1.trim().length < 3) {
      newErrors.addressLine1 = "Address Line 1 is too short"
    }
    if (addressLine1 && addressLine1.length > 100) {
      newErrors.addressLine2 = "Address Line 1 cannot exceed 100 characters"
    }
 
    if (addressLine2 && addressLine2.length > 100) {
      newErrors.addressLine2 = "Address Line 2 cannot exceed 100 characters"
    }
    if (addressLine2.trim().length < 3) {
      newErrors.addressLine2 = "Address Line 2 is too short"
    }
 
    if (!city) newErrors.city = "City is missing"
    if (!stateName) newErrors.state = "State is missing"
    if (!pincode) newErrors.pincode = "Pincode is missing"
    else if (!/^[0-9]{6}$/.test(pincode)) newErrors.pincode = "Pincode must be 6 digits"
    if (!country) newErrors.country = "Country is missing"
 
    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
    }
  return (
    <>
    <div style={{
            background: "white", borderRadius: 14, border: "1px solid #e8eaf0",
            padding: "28px 24px",
            width:"100%"
          }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20 }}>
              <span style={{ color: "#1a3fc4" }}></span>
              <h2 style={{ fontSize: 17, fontWeight: 600, color: "#1a1d2e", margin: 0 }}>Select Billing Address <span style={{color:"red"}}>*</span></h2>
            </div>
 
            <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 32 }}>
              {companyAddresses&&companyAddresses.map((loc,index) => {
                const isSelected = selectedIndex === index;
                return (
                  <div
                    key={loc.id}
                    onClick={() => handleLocationSelect(loc,index)}
                    style={{
                      border: isSelected ? "2px solid #1a3fc4" : "2px solid #e8eaf0",
                      borderRadius: 10,
                      padding: "14px 18px",
                      cursor: "pointer",
                      background: isSelected ? "#f0f3ff" : "white",
                      display: "flex", alignItems: "flex-start", gap: 14,
                      transition: "all 0.15s",
                    }}
                  >
                    <div style={{ marginTop: 2, flexShrink: 0 }}>
                      <div style={{
                        width: 18, height: 18, borderRadius: "50%",
                        border: isSelected ? "2px solid #1a3fc4" : "2px solid #c5c9d8",
                        background: isSelected ? "#1a3fc4" : "white",
                        display: "flex", alignItems: "center", justifyContent: "center",
                      }}>
                        {isSelected && <div style={{ width: 7, height: 7, borderRadius: "50%", background: "white" }} />}
                      </div>
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: isSelected ? "#1a3fc4" : "#1a1d2e", letterSpacing: 0.5, marginBottom: 3 }}>{loc.address1}</div>
                      <div style={{ fontSize: 13, color: "#4b5563" }}>{loc.address2}</div>
                      <div style={{ fontSize: 13, color: "#6b7280" }}>{loc.city}, {loc.state_name} - {loc.pincode}</div>
                      <div style={{ fontSize: 14, color: "#6b7280",fontWeight: 700, margin:"7px 0px" }}>{loc.type}</div>
                    </div>
                    {isSelected && (
                      <span style={{
                        fontSize: 10, fontWeight: 700, letterSpacing: 0.8,
                        background: "#1a3fc4", color: "white",
                        padding: "3px 10px", borderRadius: 20,
                        flexShrink: 0, alignSelf: "center"
                      }}>SELECTED</span>
                    )}
                  </div>
                );
              })}
            </div>
 
            {/* Edit Address Details */}
            <div>
              <div style={{ fontSize: 12, fontWeight: 700, color: "#1a1d2e", letterSpacing: 1, textTransform: "uppercase", marginBottom: 20 }}>Edit Address Details</div>
 
              <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
               <div className={style.anFormGroup}>
                               <label className={style.anLabel}>Address Line 1 <span style={{color:"red"}}>*</span></label>
                               <input
                                 className={style.anInput}
                                 placeholder="Street address or P.O. Box"
                                 value={addressLine1}
                                 onChange={handleLine1Change}
                               />
                               {errors.addressLine1 && (
              <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                {errors.addressLine1}
              </span>
            )}
                             </div>
 
                             <div className={style.anFormGroup}>
                               <label className={style.anLabel}>Address Line 2 <span style={{color:"red"}}>*</span></label>
                               <input
                                 className={style.anInput}
                                 placeholder="Street address or P.O. Box"
                                 value={addressLine2}
                                 onChange={handleLine2Change}
                               />
                               {errors.addressLine2 && (
              <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                {errors.addressLine2}
              </span>
            )}
                             </div>
 
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                  <div>
                    <label style={{ fontSize: 12, color: "#6b7280", marginBottom: 6, display: "block" }}>City <span style={{color:"red"}}>*</span></label>
                    <div style={{ position: "relative" }}>
                      <input
                        value={city}
                        placeholder='eg. Gurugram'
                        disabled={companyAddresses.length>0}
                        style={{
                          width: "100%", padding: "11px 40px 11px 16px",
                          border: "1px solid #e8eaf0", borderRadius: 8,
                          fontSize: 14, color: "#6b7280",
                          background: "#f9fafb", boxSizing: "border-box",
                          outline: "none",
                          backgroundColor:companyAddresses.length<0&&"white"
                        }}
                        onChange={e=>setCity(e.target.value)}
                      />
                      {errors.city && (
                <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                  {errors.city}
                </span>
              )}
                      <span style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}>
                        {/* <LockIcon /> */}
                      </span>
                    </div>
                  </div>
                  <div>
                    <label style={{ fontSize: 12, color: "#6b7280", marginBottom: 6, display: "block" }}>State <span style={{color:"red"}}>*</span></label>
                    <div style={{ position: "relative" }}>
                      <input
                        value={stateName}
                        readOnly
                        style={{
                          width: "100%", padding: "11px 40px 11px 16px",
                          border: "1px solid #e8eaf0", borderRadius: 8,
                          fontSize: 14, color: "#6b7280",
                          background: "#f9fafb", boxSizing: "border-box",
                          outline: "none",
                        }}
                      />
                      {errors.state && (
                <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                  {errors.state}
                </span>
              )}
                      <span style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}>
                        {/* <LockIcon /> */}
                      </span>
                    </div>
                  </div>
                </div>
 
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                  <div>
                    <label style={{ fontSize: 12, color: "#6b7280", marginBottom: 6, display: "block" }}>Pincode <span style={{color:"red"}}>*</span></label>
                    <div style={{ position: "relative" }}>
                      <input
                        value={pincode}
                        placeholder='eg. 122022'
                        disabled={companyAddresses.length>0}
                        style={{
                          width: "100%", padding: "11px 40px 11px 16px",
                          border: "1px solid #e8eaf0", borderRadius: 8,
                          fontSize: 14, color: "#6b7280",
                          background: "#f9fafb", boxSizing: "border-box",
                          outline: "none",
                          backgroundColor:companyAddresses.length<0&&"white"
                        }}
                        onChange={e=>setPincode(e.target.value)}
                      />
                      {errors.pincode && (
                <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                  {errors.pincode}
                </span>
              )}
                      <span style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}>
                        {/* <LockIcon /> */}
                      </span>
                    </div>
                  </div>
                  <div>
                    <label style={{ fontSize: 12, color: "#6b7280", marginBottom: 6, display: "block" }}>Country <span style={{color:"red"}}>*</span></label>
                    <div style={{ position: "relative" }}>
                      <input
                        value={country}
                        readOnly
                        style={{
                          width: "100%", padding: "11px 40px 11px 16px",
                          border: "1px solid #e8eaf0", borderRadius: 8,
                          fontSize: 14, color: "#6b7280",
                          background: "#f9fafb", boxSizing: "border-box",
                          outline: "none",
                        }}
                      />
                      {errors.country && (
                <span style={{ color: "#dc2626", fontSize: 12, marginTop: 4, display: "block" }}>
                  {errors.country}
                </span>
              )}
                      <span style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", color: "#9ca3af" }}>
                        {/* <LockIcon /> */}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
 
            {isSaved && (
        <div style={{
          marginTop: 16,
          padding: "10px 14px",
          background: "#dcfce7",
          border: "1px solid #bbf7d0",
          borderRadius: 6,
          color: "#166534",
          fontSize: 13,
          display: "flex",
          alignItems: "center",
          gap: 8,
        }}>
          ✓ Billing address saved. You can now proceed to submit the form.
        </div>
      )}
            {/* Action buttons */}
        {!isSaved &&<div style={{ display: "flex", justifyContent: "flex-end", gap: 12, marginTop: 32 }}>
              <button style={{
                padding: "11px 24px", borderRadius: 8,
                border: "none",
                background: "linear-gradient(135deg, #1a3fc4 0%, #1230a0 100%)",
                color: "white",
                fontSize: 14, fontWeight: 600, cursor: "pointer",
              }}
              onClick={handleSave}
              disabled={isSaved}
              >
                {isSaved ? "✓ Saved" : "Save & Continue"}
              </button>
            </div>}
          </div>
    </>
  )
}

export default CompanyBillingAddress